import { useState, useEffect } from 'react'

const ADMIN_PASSWORD = 'readquran114'
const AUTH_KEY = 'quran_admin_auth'

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [showAuthModal, setShowAuthModal] = useState(false)

  useEffect(() => {
    const savedAuth = localStorage.getItem(AUTH_KEY)
    if (savedAuth === 'true') {
      setIsAuthenticated(true)
    }
  }, [])

  const authenticate = (password) => {
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true)
      localStorage.setItem(AUTH_KEY, 'true')
      setShowAuthModal(false)
      return true
    }
    return false
  }

  const logout = () => {
    setIsAuthenticated(false)
    localStorage.removeItem(AUTH_KEY)
    setShowAuthModal(false)
  }

  const requestAuth = () => {
    setShowAuthModal(true)
  }

  return {
    isAuthenticated,
    showAuthModal,
    setShowAuthModal,
    authenticate,
    logout,
    requestAuth
  }
}